module.exports = __webpack_public_path__ + "static/img/6areaA_1.0fed100.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/6areaA_1.png
// module id = 1046
// module chunks = 1